import React from "react";
import { userRoleSuperAdmin } from "../../utility/constants";
import { useSelector } from "react-redux";

import FooterMenu from "../../components/FooterMenu";
import SideMenuAdmin from "../../components/SideMenuAdmin";

const Footer = () => {
  const role = useSelector((state) => {
    if (state.auth.userData) {
      return state.auth.userData.role;
    }
    return null;
  });
  return <FooterMenu />;
};

export default Footer;
